import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import "./AllProjects.css";
import AllProjectsHero from "../../components/pages/AllProjects/AllProjectsHero/AllProjectsHero";
import ExploreAllProjects from "../../components/pages/AllProjects/ExploreAllProjects/ExploreAllProjects";
import AboutStartNewProject from "../../components/pages/About/AboutStartNewProject/AboutStartNewProject";
import { getPageContent } from "../../api/content";
import {
  findPageSection,
  getAboutStartNewProjectContent,
  unwrapSectionData,
} from "../../utils/aboutStartNewProjectSection";

const AllProjects = () => {
  const { i18n } = useTranslation();
  const [pageContent, setPageContent] = useState({});
  const [aboutContent, setAboutContent] = useState({});

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      const language = (i18n.language || "en").toLowerCase();
      const pageAliases = ["allprojects", "all-projects", "projects", "allproject"];

      const aboutPromise = getPageContent({ page: "about", language }).catch(() => ({}));

      let projectsData = {};
      for (const page of pageAliases) {
        try {
          const data = await getPageContent({ page, language });
          if (data && typeof data === "object" && Object.keys(data).length) {
            projectsData = data;
            break;
          }
        } catch {
          // try next alias
        }
      }

      const aboutData = await aboutPromise;
      if (!isMounted) return;
      setPageContent(projectsData);
      setAboutContent(aboutData && typeof aboutData === "object" ? aboutData : {});
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [i18n.language]);

  const heroSection =
    findPageSection(pageContent, "hero") ||
    findPageSection(pageContent, "allprojectshero") ||
    findPageSection(pageContent, "allprojects");

  return (
    <div className="allprojects-page">
      <Navbar />
      <AllProjectsHero content={unwrapSectionData(heroSection)} />
      <div className="allprojects-page-content-guide">
        <div id="all-projects-explore">
          <ExploreAllProjects />
        </div>
        <AboutStartNewProject content={getAboutStartNewProjectContent(aboutContent)} />
      </div>
      <Footer />
    </div>
  );
};

export default AllProjects;
